import { IUpdatePesquisaSatisfacaoUseCase } from "../../../presentation/useCases/update/update_pesquisa_satisfacao_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdatePesquisaSatisfacaoUseCase
 */

export class UpdatePesquisaSatisfacaoUseCase implements IUpdatePesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async updatePesquisaSatisfacao(
    idPesquisaSatisfacao: number,
    status: number,
    codigo: string,
    descricao: string,
  ): Promise<void> {
    await this.repository.updatePesquisaSatisfacao(
      idPesquisaSatisfacao,
      status,
      codigo,
      descricao,
    );
  }
}
